import { Box, Stack, Typography, alpha } from '@mui/material';

export const PredictionsAndMetadataImageContent = () => (
  <>
    <Stack>
      <Typography fontSize="8px">Reasons</Typography>
      <Stack mt={0.5} spacing={1.5} direction="row" sx={{ opacity: 0.7 }}>
        <Box width={105} height={5} borderRadius={4} bgcolor="primary.main" />
        <Box width={105} height={5} borderRadius={4} bgcolor="primary.main" />
      </Stack>
    </Stack>
    <Stack>
      <Typography fontSize="8px">Tracked Keywords</Typography>
      <Stack mt={0.5} spacing={1} direction="row" sx={{ opacity: 0.7 }}>
        <Box width={55} height={5} borderRadius={4} bgcolor="primary.main" />
        <Box width={55} height={5} borderRadius={4} bgcolor="primary.main" />
      </Stack>
    </Stack>
    <Stack>
      <Typography fontSize="8px">Metadata</Typography>
      <Stack mt={0.5} spacing={1} direction="row" sx={{ opacity: 0.7 }}>
        <Box width={55} height={5} borderRadius={4} bgcolor="primary.main" />
        <Box width={55} height={5} borderRadius={4} bgcolor="primary.main" />
      </Stack>
    </Stack>
  </>
);

export const PredictionsAndMetadataImage = () => (
  <Box
    width={250}
    borderRadius={1}
    bgcolor={(theme) => alpha(theme.palette.text.primary, 0.1)}
  >
    <Stack spacing={0.6} padding={1}>
      <PredictionsAndMetadataImageContent />
    </Stack>
  </Box>
);
